import React from 'react';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

import { formatMoney } from '../../../utils/number';
import { canBeSelected } from '../../../utils/productUtils';
import PricesComponent from '../../Shared/PricesComponent';

const CatalogProductItem = ({
  product,
  onSelectProduct
}) => {
  const {
    title,
    price,
    discounted_price: discountedPriceRaw,
    image_url: imageUrl,
    product_variant_combinations
  } = product;
  const { retailer } = useSelector((reduxState) => reduxState.retailerReducer);
  const hasCombinations = !isEmpty(product_variant_combinations);

  let image = '';

  if (imageUrl) {
    image = imageUrl.url;
  };

  const onClickProduct = () => {
    if (window.innerWidth > 760) {
      onSelectProduct(product);
    } else {
      window.location.href = `/product/${product.web_id}`;
    }
  };

  const getFromPrice = () => {
    const prices = product_variant_combinations.map(combination => {
      const disc = Number(combination.discounted_price || 0);
      const regular = Number(combination.price);
      return (disc > 0 && disc < regular) ? disc : regular;
    });

    return Number(Math.min(...prices));
  };

  const getProductPriceInfo = () => {
    if (!hasCombinations) {
      const disc = Number(discountedPriceRaw || 0);
      const regular = Number(price);
      if (disc > 0 && disc < regular) {
        return { currentPrice: disc, strikethroughPrice: regular };
      } else if (disc > regular) {
        return { currentPrice: regular, strikethroughPrice: disc };
      }
      return { currentPrice: regular, strikethroughPrice: 0 };
    }

    const minPrice = getFromPrice();
    const minComb = product_variant_combinations.find(combination => {
      const disc = Number(combination.discounted_price || 0);
      const regular = Number(combination.price);
      const eff = (disc > 0 && disc < regular) ? disc : regular;
      return eff === minPrice;
    });

    const disc = Number(minComb?.discounted_price || discountedPriceRaw || 0);
    const regular = Number(minComb?.price || price);
    let strikethrough = 0;
    if (disc > 0 && disc < regular) {
      strikethrough = regular;
    } else if (disc > regular) {
      strikethrough = disc;
    }

    return { currentPrice: minPrice, strikethroughPrice: strikethrough };
  };

  const { currentPrice, strikethroughPrice } = getProductPriceInfo();
  const showStrikethrough = strikethroughPrice > 0 && strikethroughPrice > currentPrice;

  return (
    <div className="col-6 col-md-4 catalog-product-item pb-4">
      <div onClick={onClickProduct} role="button">
        <div className="catalog-product-item-image">
          <img src={image} alt="" className={!canBeSelected(product) ? 'opacity-50' : ''} />
        </div>
        <p className="pt-3 mb-1 catalog-product-item-name">{title}</p>
        <p className="catalog-product-item-price">
          <PricesComponent>
            {hasCombinations && ('Desde ')}
            {showStrikethrough && (
              <span className="text-muted text-decoration-line-through me-2">
                {retailer.currency}{formatMoney(strikethroughPrice)} {retailer.currency_code}
              </span>
            )}
            <span>
              {retailer.currency}{formatMoney(currentPrice)} {retailer.currency_code}
            </span>
          </PricesComponent>
        </p>
        {canBeSelected(product) && (
          <button
            type="button"
            className="btn btn-main text-white d-none d-md-block"
          >
            Comprar
          </button>
        )}

        {!canBeSelected(product) && (
          <span className="sold-out-product">Agotado</span>
        )}
      </div>
    </div>
  );
};

export default CatalogProductItem;
